import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TRANSITIONS, TYPOGRAPHY } from '../../../../styles/theme'
import { QuestionLabel, InputWrapper, HintText, focusStyle } from './shared'

interface OpenQuestionProps {
  question: string
  value: string
  onChange: (value: string) => void
}

const Textarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: ${SPACING.md};
  border: 1px solid var(--color-border-dark);
  border-radius: ${BORDER_RADIUS.lg};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: 1.6;
  color: var(--color-text-primary);
  background: var(--color-input-bg);
  resize: vertical;
  font-family: inherit;
  transition: ${TRANSITIONS.fast};
  box-sizing: border-box;

  &::placeholder {
    color: var(--color-text-muted);
  }

  &:hover {
    border-color: var(--color-primary);
  }

  &:focus {
    ${focusStyle}
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${SPACING.xs};
`

export function OpenQuestion({ question, value, onChange }: OpenQuestionProps) {
  return (
    <InputWrapper>
      <QuestionLabel>{question}</QuestionLabel>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Share your experience…"
        rows={4}
      />
      {value.length > 0 && (
        <Footer>
          <HintText>{value.length} characters</HintText>
        </Footer>
      )}
    </InputWrapper>
  )
}
